// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

var minWidthDesktop = "(min-width: 560px)";

var wideDesktop = "(min-width: 1024px)";

function useMediaQuery(query) {
  var match = React.useState(function () {
        return false;
      });
  var setMatches = match[1];
  var matches = match[0];
  React.useEffect((function () {
          Curry._1(setMatches, (function (param) {
                  return matchMedia(query).matches;
                }));
          var listener = function (param) {
            Curry._1(setMatches, (function (param) {
                    return matchMedia(query).matches;
                  }));
          };
          document.addEventListener("resize", listener);
          return (function (param) {
                    document.removeEventListener("resize", listener);
                  });
        }), [
        matches,
        query
      ]);
  return matches;
}

function isMobile(param) {
  return useMediaQuery(minWidthDesktop);
}

function isWideDesktop(param) {
  return useMediaQuery(wideDesktop);
}

export {
  minWidthDesktop ,
  wideDesktop ,
  useMediaQuery ,
  isMobile ,
  isWideDesktop ,
}
/* react Not a pure module */
